export const apiBaseUrl =
  import.meta.env.VITE_API_BASE_URL || 'https://api.sessions.chxse.dev/api/v1';
